module.exports = __webpack_public_path__ + "img/collection-engagementRingsBudgetLow@2x.297a43a.webp";